import axios from 'axios';
import apiUrl from '../constants';


export function fetchClientList(input, token){
    return axios({
            method: 'post',
            url: apiUrl.api_url + 'getClientList',
            data: input,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
}

export function disputeSubReason(){
    let disputeSubReasons = [
        {id: 35,	label: 'Dispute WIP'},
        {id: 34,	label: 'Dispute Closed'},
        {id: 33,	label: 'Dispute Rejected by Executive'},
        {id: 32,	label: 'Dispute Reopend'},
        {id: 31,	label: 'Dispute Rejected by RM'},
        {id: 30,	label: 'Dispute Accepted by RM '},
        {id: 29,	label: 'Dispute Accepted by Executive'},
        {id: 28,	label: 'Dispute Logged'},
    ]
    return disputeSubReasons;
}


export function externalDisputeActions(){
    let externalDisputeActions = {}
        externalDisputeActions[33] = 'Dispute Reject'; //By Executive
        externalDisputeActions[31] = 'Dispute Reject'; //By RM
        externalDisputeActions[30] = 'Dispute Accept'; //By RM
        externalDisputeActions[29] = 'Dispute Accept'; //By Executive
    
    return externalDisputeActions;
}


export function fetchExternalDisputeReasons(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'externalDisputeReason',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function bulkAcceptDispute(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'acceptBulkDispute',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function externalDisputeAction(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'externalDisputeAction',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function changeBucketOwner(input,token){
    console.log(token);
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'changeDisputeBucket',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function uploadDisputeFiles(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'uploadFilesForDispute',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function searchapiForRMapprovalPage(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'searchapiForRMapprovalPage',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}


export function fetchClientImages(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'disputeAssets',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}


export function fetchimageObject(key, shippingID, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'getListObjectFroms3',
        data: {
            key: key,
            shippingID: shippingID ? shippingID : null
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function extractObjectFromKey(key, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'fetchImages3',
        data: {
            fileName: "no_need_for_this",
            key: key
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function getAssignBatchId(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'getAssignBatchId',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function sortingImages(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'sortingImages',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function bulkDisputeSampleCSV(token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'bulkDisputeSampleCSV',
        data: {},
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function disputeLogs(input,token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'disputeLogs',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function getImage(input,token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'flagDeliveryImages',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function getReasonSubReason(input,token){
    return axios({
        method: 'post',
        url : apiUrl.api_url + 'disputeReasonSubReason',
        data : input,
        headers : {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function getRTOProfarma(input,token){
    return axios({
        method: 'post',
        url : apiUrl.api_url + 'getRTOperforma',
        data : input,
        headers : {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function getInternalLogs(input,token){
    return axios({
        method: 'post',
        url : apiUrl.api_url + 'investigationInternalLogs',
        data : input,
        headers : {
            'Authorization': 'Bearer ' + token
        }
    })
}
export function qcImages(input,token){
    return axios({
        method: 'post',
        url : apiUrl.api_url + 'qcImagesFeching',
        data : input,
        headers : {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function getVideoUrl(input,token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'getDisputeProofs',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

export function getShipmentTypeList(input, token) {
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'shipmentTypeList',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function getProofs(input,token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'getProofsConfig',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function updateProofs(input, token) {
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'updateDisputeConfigurations',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function getaudittrails(input,token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'disputeConfigAuditTrail',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function clientlevelconfigs(input,token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'getClientLevelConfigs',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export function getImgVidProofs(input,token){
    return axios({
        method: 'get',
        url: `${apiUrl.api_url}getSTDProofs?shippingid=${input.awb}&status=${input.status}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
}
export function raisedDispute(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'raisedDispute',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function getPresignedUrl(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'getPresignedUrl',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function saveUploadedMedia(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'saveUploadedMedia',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
export function viewDisputeDetails(input, token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'viewDisputeDetails',
        data: input,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}


// WEBPACK FOOTER //
// ./src/services/externalDispute.js